<h1 class="c11n-text-xl-headline c11n-space-stack-6x">{{
  content.removeAccessFlow.review.title
}}</h1>

<div class="review-container" data-cy="raf-review-and-submit-container">
    <p class="c11n-text-md-bold c11n-space-stack-1_5x">
        {{ description | async }}
    </p>

    <ul role="list" class="review-container__account-list">
        <li *ngFor="let account of (selectedAccounts | async)" class="c11n-text-md">
            {{ account.accountName }}
        </li>
    </ul>
</div>
